import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { get } from 'lodash'
import { Form } from 'components/layout'
import { ActivityLog } from 'components/sections/activities'
import { form } from 'helpers/decorators'
import validate from 'models/activities/validateLogs'

const enhance = compose(
  form({
    form: 'editLogForm',
    validate
  })
)

class LogAdd extends Component {
  static propTypes = {
    disabled: PropTypes.bool.isRequired,
    submitting: PropTypes.bool,
    log: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    editActivityLog: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onRestore: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    isBulkLogsEnabled: PropTypes.bool.isRequired,
    isBulkLogsForAwardEnabled: PropTypes.bool.isRequired
  }

  static defaultProps = {
    log: {}
  }

  componentDidMount() {
    this.handleFormInitialize(this.props.log)
  }

  componentWillReceiveProps = nextProps => {
    if (this.props.log !== nextProps.log) {
      this.handleFormInitialize(nextProps.log)
    }
  }

  handleFormInitialize = data =>
    this.props.initialize({
      ...data,
      duration: data.duration / 60
    })

  render() {
    const {
      handleSubmit,
      editActivityLog,
      log,
      onClose,
      onRemove,
      onRestore,
      disabled,
      submitting,
      isBulkLogsEnabled,
      isBulkLogsForAwardEnabled
    } = this.props

    const isBulkLogs = isBulkLogsEnabled && isBulkLogsForAwardEnabled && get(this.props, 'values.groupHash') !== null

    return (
      <Form onSubmit={handleSubmit(fields => editActivityLog(log.id, fields))}>
        <ActivityLog
          id={log.id}
          isDeleted={log.deleted}
          onClose={onClose}
          onRestore={onRestore}
          onRemove={onRemove}
          disabled={disabled}
          title="Edit log"
          intlKey="logs.edit_log"
          isEditing
          isLoading={submitting}
          isBulkLogs={isBulkLogs}
          removeLogSet={get(this.props, 'values.removeLogSet')}
        />
      </Form>
    )
  }
}

export default enhance(LogAdd)
